module.exports = __webpack_public_path__ + "images/top-gainers-blue-b42ef5a7.svg";